import { useRef, useState } from "react";
import { FaCaretRight } from "react-icons/fa";

const Collapsible = ({
    header = "",
    headerContainerClassName,
    headerContainerStyle,
    headerStyle,
    headerClassName,
    children,
    isCollapse = true,
    iconPlus = false,
    id = 0,
}) => {
    const [open, setOpen] = useState(true);
    const containerRef = useRef(null);
    const toggle = () => {
        setOpen(!open);
    };

    return (
        <>
            <button
                ref={containerRef}
                id={id}
                style={headerContainerStyle}
                onClick={toggle}
                className="flex items-center gap-2 cursor-pointer pb-4 pt-6"
            >
                <FaCaretRight className={`${open ? "rotate-90" : "rotate-0"} transition-all duration-300`} />
                <h4 className="text-[14px] font-bold bg-[#2b593f] py-1 px-2 rounded">{header}</h4>
            </button>
            <div
                ref={(n) => {
                    if (n) {
                        if (open) n.style.height = n.scrollHeight + "px";
                        else n.style.height = "0";
                    }
                }}
                className="overflow-hidden transition-all duration-300 text-[14px]"
            >
                {children}
            </div>
        </>
    );
};

export default Collapsible;
